{
  "title": "Trợ lý",
  "newChat": "Chat mới",
  "placeholder": "Mô tả học viên cần thêm...",
  "confirm": "Xác nhận",
  "cancel": "Huỷ",
  "undo": "Hoàn tác",
  "resultLine": "Đã tạo {{created}}, cập nhật {{updated}}",
  "undoneLine": "Đã hoàn tác",
  "sentinelConfirmLabel": "Xác nhận",
  "sentinelUndoLabel": "Hoàn tác",
  "history": "Lịch sử hội thoại",
  "historyEmpty": "Chưa có hội thoại nào",
  "historyDeleteTitle": "Xoá hội thoại này?",
  "historyDeleteBody": "Hành động này không thể hoàn tác. Toàn bộ nội dung hội thoại sẽ bị xoá vĩnh viễn.",
  "historyDeleteCancel": "Huỷ",
  "historyDeleteConfirm": "Xoá",
  "credits": {
    "remaining": "Còn {{remaining}}/{{limit}} credit AI tháng này",
    "unlimited": "AI không giới hạn",
    "exhausted": "Hết credit AI tháng này, nâng cấp gói để dùng tiếp"
  }
}
